import { getStringWithoutLeadingSlash } from 'helpers/parsing/stringWithoutSlash';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useDomainConfig } from 'hooks/useDomainConfig';
import Head from 'next/head';
import { useMemo } from 'react';
import { BreadcrumbItemType } from 'types/breadcrumb';

type BreadcrumbsMetadataProps = {
    breadcrumbs: BreadcrumbItemType[];
};

export const BreadcrumbsMetadata: FC<BreadcrumbsMetadataProps> = ({ breadcrumbs }) => {
    const { url } = useDomainConfig();
    const t = useTypedTranslationFunction();

    const breadcrumbItems: BreadcrumbItemType[] = useMemo(
        () => [{ name: t('Home page'), slug: '/' }, ...breadcrumbs],
        [breadcrumbs, t],
    );

    return (
        <Head>
            <script
                type="application/ld+json"
                id="breadcrumbs-metadata"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify([
                        {
                            '@context': 'https://schema.org',
                            '@type': 'BreadcrumbList',
                            itemListElement: breadcrumbItems.map((breadcrumb, index) => {
                                const breadcrumbAbsoluteUrl = url + getStringWithoutLeadingSlash(breadcrumb.slug);

                                return {
                                    '@type': 'ListItem',
                                    position: index + 1,
                                    name: breadcrumb.name,
                                    item: index === breadcrumbItems.length - 1 ? undefined : breadcrumbAbsoluteUrl,
                                };
                            }),
                        },
                    ]),
                }}
                key="breadcrumbs-metadata"
            />
        </Head>
    );
};
